export enum UserFunctionEnum {
  // Customer Approve
  CaTable = 'CA_TABLE',
  AddPart = 'ADD_PART',
  CaExportCsv = 'CA_EXPORT_CSV',
  InTableEditing = 'IN_TABLE_EDITING',
  BulkActionsApprove = 'BULK_ACTIONS_APPROVE',
  BulkActionsAssign = 'BULK_ACTIONS_ASSIGN',
  BulkActionsUnassign = 'BULK_ACTIONS_UNASSIGN',
  QuickActionsApprove = 'QUICK_ACTIONS_APPROVE',
  CaAddImages = 'CA_ADD_IMAGES',
  PartEditor = 'PART_EDITOR',
  PartEditorSave = 'PART_EDITOR_SAVE',
  PartEditorSendToSparrow = 'PART_EDITOR_SEND_TO_SPARROW',
  PartEditorApprove = 'PART_EDITOR_APPROVE',
  PartEditorCommentsHistory = 'PART_EDITOR_COMMENTS_HISTORY',
  PartEditorCommentAndSubmit = 'PART_EDITOR_COMMENT_AND_SUBMIT',
  PartEditorAssignInternally = 'PART_EDITOR_ASSIGN_INTERNALLY',
  CaSupplyAlternative = 'CA_SUPPLY_ALTERNATIVE',
  SiteExtension = 'SITE_EXTENSION',
  // Stock Management
  SmTable = 'SM_TABLE',
  PdpCatalogueData = 'PDP_CATALOGUE_DATA',
  PdpStockData = 'PDP_STOCK_DATA',
  SmAddStock = 'SM_ADD_STOCK',
  SmUseStock = 'SM_USE_STOCK',
  SmAddImages = 'SM_ADD_IMAGES',
  SmDeleteImages = 'SM_DELETE_IMAGES',
  SmDeletePart = 'SM_DELETE_PART',
  PdpSaveChangesAndCancel = 'PDP_SAVE_CHANGES_AND_CANCEL',
  SmDispositionManagement = 'SM_DISPOSITION_MANAGEMENT',
  // Planning
  Overview = 'OVERVIEW',
  Plan = 'PLAN',
  PartDetails = 'PART_DETAILS',
  BulkActionsAccept = 'BULK_ACTIONS_ACCEPT',
  BulkActionsKeepCurrent = 'BULK_ACTIONS_KEEP_CURRENT',
  BulkActionsReturnToReview = 'BULK_ACTIONS_RETURN_TO_REVIEW',
  PlanningExportCsv = 'PLANNING_EXPORT_CSV',
  IncludeInPlanning = 'INCLUDE_IN_PLANNING',
  RecommendationAccept = 'RECOMMENDATION_ACCEPT',
  RecommendationKeepCurrent = 'RECOMMENDATION_KEEP_CURRENT',
  RecommendationEdit = 'RECOMMENDATION_EDIT',
  CategorySettings = 'CATEGORY_SETTINGS',
  // Pool
  PoolTransactions = 'POOL_TRANSACTIONS',
  PoolSearch = 'POOL_SEARCH',
  // User Management
  UserManagement = 'USER_MANAGEMENT',
  CaRoleManagement = 'CA_ROLE_MANAGEMENT',
  SmRoleManagement = 'SM_ROLE_MANAGEMENT',
  PlanningRoleManagement = 'PLANNING_ROLE_MANAGEMENT',
  PoolRoleManagement = 'POOL_ROLE_MANAGEMENT',
}
